import { Injectable } from '@angular/core';
import { BehaviorSubject } from '@shared/rx';

@Injectable()
export class XUXDrawerSidebarService {
  public slideState: string = 'closed';
  public slideState$: BehaviorSubject<string> = new BehaviorSubject<string>(
    // eslint-disable-next-line no-invalid-this
    this.slideState,
  );

  public open(): void {
    this.slideState = 'open';
    this.slideState$.next(this.slideState);
  }
  public close(): void {
    this.slideState = 'closed';
    this.slideState$.next(this.slideState);
  }
  public toggle(): void {
    this.slideState = this.slideState === 'closed' ? 'open' : 'closed';
    this.slideState$.next(this.slideState);
  }
  public openOnDesktop(): void {
    if (window.innerWidth >= 768) {
      this.slideState = 'open';
    }
    this.slideState$.next(this.slideState);
  }
  public closeOnMobile(): void {
    if (window.innerWidth < 768) {
      this.slideState = 'closed';
    }
    this.slideState$.next(this.slideState);
  }
}
